import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Bathtub from './Bathtub';
import Dwdf from './Dwdf';
import WT from './WT';
import Krw from './Krw';
import NotFound from './NotFound';

import ReactGA from "react-ga4";
import {GOOGLE_ANALYTICS} from '../config/Config';

class Homepage extends Component {

    renderSwitch(id, name) {

        ReactGA.initialize([
            {
                trackingId: GOOGLE_ANALYTICS,
            }
        ]);
        switch (name) {

            case 'bathtub':
                if (id.length > 0) {
                    ReactGA.send({hitType: "pageview", page: "/configurator/bathtub",  title: "Configurator Bathtub"});
                    return <Bathtub articleID={id} />;
                }
                return <NotFound />;
            case 'dwdf':
                if (id.length > 0) {
                    ReactGA.send({hitType: "pageview", page: "/configurator/dwdf",  title: "Configurator DWDF"});
                    return <Dwdf articleID={id} />;
                }
                return <NotFound />;
            case 'wt':
                if (id.length > 0) {
                    ReactGA.send({hitType: "pageview", page: "/configurator/wt",  title: "Configurator WT"});
                    return <WT articleID={id} />;
                }
                return <NotFound />;
            case 'krw':
                if (id.length > 0) {
                    ReactGA.send({hitType: "pageview", page: "/configurator/krw",  title: "Configurator KRW"});
                    return <Krw articleID={id} />;
                }
                return <NotFound />;
            default:
                ReactGA.send({hitType: "pageview", page: "/configurator/notfound",  title: "Configurator NotFound"});
                return <NotFound />;

        }
    }

    render() {
        const {product_id, product} = this.props.match.params;
        return this.renderSwitch(product_id, product);
    }

};

/**
 * Prop types
 * @type {{match: *}}
 */
Homepage.propTypes = {
    match: PropTypes.object.isRequired,
};

export default Homepage;



// WEBPACK FOOTER //
// ./src/components/Homepage.js